import React from 'react';
import { FormCheckbox } from '@hvcgroep/design-system';
import { useTranslation } from 'react-i18next';
import InformationForm from './InformationForm';
import { TERMS_CONDITIONS_URL } from '../../config/constants';
import './style.scss';

const Information = ({ setIsAnonymous, isAnonymous }) => {
  const { t } = useTranslation();

  const _handleAnonymity = () => {
    if (isAnonymous) {
      return (
        <p className="information">{t('reports.stepper.information.isAnonymous')}</p>
      );
    } else {
      return (
        <>
          <InformationForm />
          <FormCheckbox
            name="termsConditions"
            visualValidation={false}
            label={
              <>
                {t('reports.stepper.information.termsConditions')}&nbsp;
                <a className="link-display-content" href={TERMS_CONDITIONS_URL} target="blank">
                  {t('reports.stepper.information.termsConditionsLink')}
                </a>
              </>
            }
          />
        </>
      );
    }
  };

  return (
    <>
      <p className="override-margin">{t('reports.stepper.information.subtitle')}</p>
      <FormCheckbox
        name="isAnonymous"
        visualValidation={false}
        onChange={() => { setIsAnonymous(!isAnonymous); }}
        label={t('reports.stepper.information.checkbox')}
      />
      {_handleAnonymity()}
    </>
  );
};

export default Information;
